import useMediaRecorder from '@wmik/use-media-recorder';
import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { Error } from '../Error';
import ButtonGroup from './ButtonGroup';
import Placeholder from './Placeholder';
import { Playback } from './Playback';
import Preview from './Preview';
import SafariInstructions from './SafariInstructions';

interface IProps {
  onConfirmed: Function;
}

export const Capture: React.FC<IProps> = ({ onConfirmed }) => {
  const {
    error,
    status,
    mediaBlob,
    stopRecording,
    startRecording,
    liveStream,
  } = useMediaRecorder({
    blobOptions: { type: 'video/mp4' },
    mediaStreamConstraints: { audio: true, video: true },
  });

  if (error) {
    console.error(error);
    if (
      error.message.includes('MediaRecorder is not supported in this browser')
    ) {
      return <SafariInstructions />;
    }
    return (
      <Error>
        <pre>{JSON.stringify(error, null, 2)}</pre>
      </Error>
    );
  }

  return (
    <AnimatePresence>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          border: '1px solid #c9c9c9',
        }}
      >
        {(status === 'idle' ||
          status === 'acquiring_media' ||
          status === 'ready') && <Placeholder />}
        {status === 'recording' && <Preview liveStream={liveStream} />}
        {status === 'stopped' && mediaBlob && (
          <Playback mediaBlob={mediaBlob} />
        )}
        <ButtonGroup
          status={status}
          startRecording={startRecording}
          stopRecording={stopRecording}
          onConfirmed={() => onConfirmed(mediaBlob)}
          disabled={!mediaBlob}
        />
      </div>
    </AnimatePresence>
  );
};
